import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { EASE, IMAGES } from "../lib/site";

const PILLARS = [
  "Every gift is traced directly to the family it reaches",
  "Rapid-response aid for families in crisis — food, rent, medicine",
  "Rooted in New Jersey, serving communities at home and abroad",
];

export const Mission = () => (
  <section id="mission" data-testid="mission-section" className="py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-16 px-5 sm:px-8 lg:grid-cols-2">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, ease: EASE }}
      >
        <p className="eyebrow">Our mission</p>
        <h2 className="mt-5 font-serif text-4xl font-medium leading-[1.15] tracking-tight text-ink sm:text-5xl">
          We move help directly to the families who need it —{" "}
          <em className="text-brand">no middlemen, no lost dignity.</em>
        </h2>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-inksoft">
          Poverty rarely announces itself. It looks like a skipped meal, a
          winter coat that no longer fits, a child who stops dreaming out loud.
          DAIO exists to catch those moments — with groceries before the
          cupboard is empty, rent before the eviction notice, tuition before
          the school year begins.
        </p>
        <ul className="mt-9 space-y-4">
          {PILLARS.map((p, i) => (
            <motion.li
              key={p}
              initial={{ opacity: 0, x: -16 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.15 + i * 0.1, ease: EASE }}
              className="flex items-start gap-3 text-sm font-medium text-ink"
            >
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand/10 text-brand">
                <Check className="h-3 w-3" />
              </span>
              {p}
            </motion.li>
          ))}
        </ul>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1, ease: EASE }}
        className="relative"
      >
        <div className="overflow-hidden rounded-[32px] border border-line shadow-xl">
          <img
            src={IMAGES.volunteers}
            alt="Volunteers sorting food donations"
            className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-105"
          />
        </div>
        <div className="absolute -bottom-6 -left-4 max-w-[240px] rounded-2xl border border-line bg-cardx p-5 shadow-lg sm:-left-8">
          <p className="font-serif text-4xl font-semibold text-brand">NJ</p>
          <p className="mt-1 text-xs leading-relaxed text-inksoft">
            rooted in Newark, serving families at home and abroad
          </p>
        </div>
      </motion.div>
    </div>
  </section>
);
